import { useEffect, useState } from 'react';
import BannerHome from '../components/BannerHome';
import VideoCollection from '../components/VideoCollection';
import AboutCollection from '../components/AboutCollection';
import ProductCollection from '../components/ProductCollection';
import WhyDonate from '../components/WhyDonate';
import NewsCollection from '../components/NewsCollection';
import ReviewCollection from '../components/ReviewCollection';
import axiosInstance from '../api/axiosInstance';

const Home = () => {
  const [sliderData, setSliderData] = useState([]);
  const [campaignCategory, setCampaignCategory] = useState([]);
  const [, setCampaignData] = useState([]);
  const [testimonialData, setTestimonialList] = useState([]);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axiosInstance.get('/home');
        if (response.data.success) {
          setSliderData(response.data.slider_list);
          setCampaignCategory(response.data.campaign_categories_list);
          setCampaignData(response.data.campaign_list);
          setTestimonialList(response.data.testimonial_list);
        } else {
          console.warn('API call succeeded, but returned unsuccessful status');
        }
      } catch (error) {
        console.error('Axios error fetching data:', error);
      }
    };

    fetchHomeData();
  }, []);

  return (
    <div className='home-section'>
      <BannerHome sliderList={sliderData} />
      <VideoCollection />
      <AboutCollection />
      <ProductCollection campaignCategoryList={campaignCategory} />
      <WhyDonate />
      <NewsCollection />
      <ReviewCollection testimonialList={testimonialData}/>
    </div>
  )
}

export default Home
